import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ContactsPage from './Contacts';
import ContactDetailPage from './ContactDetail';
import LeadsPage from './Leads';
import LeadDetailPage from './LeadDetail';
import AppointmentsPage from './Appointments';
import ReportsPage from './Reports';
import SettingsUsersPage from './SettingsUsers';
import ProspezionePage from './Prospezione';

// Lazy load Navigator to avoid bundling Leaflet until needed
const NavigatorPage = lazy(() => import('./Navigator'));

export const CRMRouter: React.FC = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="contacts" replace />} />
      <Route path="contacts" element={<ContactsPage />} />
      <Route path="contacts/:id" element={<ContactDetailPage />} />
      <Route path="leads" element={<LeadsPage />} />
      <Route path="leads/:id" element={<LeadDetailPage />} />
      <Route path="prospezione" element={<ProspezionePage />} />
      <Route 
        path="navigator" 
        element={
          <Suspense fallback={<div className="p-6 text-center text-gray-500">Loading...</div>}>
            <NavigatorPage />
          </Suspense>
        } 
      />
      <Route path="appointments" element={<AppointmentsPage />} />
      <Route path="reports" element={<ReportsPage />} />
      <Route path="settings/users" element={<SettingsUsersPage />} />
      <Route path="*" element={<Navigate to="contacts" replace />} />
    </Routes>
  );
};

export default CRMRouter;



